import { render, staticRenderFns } from "./AwardManagement.vue?vue&type=template&id=eabfef1e&scoped=true"
import script from "./AwardManagement.vue?vue&type=script&lang=js"
export * from "./AwardManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabfef1e",
  null
  
)

export default component.exports